import { createFileRoute } from "@tanstack/react-router";

import ComingSoon from "../../../components/ComingSoon";

export const Route = createFileRoute("/_app/accommodation/")({
  component: Accommodation,
});

function Accommodation() {
  return <ComingSoon />;
}
